document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        const formEmbed = document.querySelector('shopify-forms-embed');
        if (!formEmbed) return;

        const shadow = formEmbed.shadowRoot;
        if (!shadow) return;

        // Create a <style> element
        const style = document.createElement('style');
        style.textContent = `
        ._formDisclaimer_cit2d_38 p {
            font-size: 0.9rem !important;
            line-height: 1 !important;
            margin-bottom: 0.5rem !important;

        }
        ._textBody_2aowh_10._checkboxLegend_1hja3_20 {
            display: none !important;
        }
        `;

        // Append it to shadow root
        shadow.appendChild(style);

        formEmbed.setAttribute('active', 'true');
    }, 500)

}) 